const config = {
  env: 'local',
  // apiUrl: "http://localhost:5570/admin/",
  // apiUrl: "http://13.202.77.166:5622/admin/"
  apiUrl: "https://api.devaji.in/admin/",
  // apiUrl : "https://p9rf4sf9-5570.inc1.devtunnels.ms/admin/"
  // shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/"
}

export default config;
